import React, { Component } from 'react';
import { Accordion, Button, Form, Grid, Icon } from 'semantic-ui-react';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME } from 'Common/FormEnum';
import { SelectField, CheckboxField } from 'Common/SemanticWrapper';
import { GenericFiltersContainer } from 'Components/filters/container';
import { AssignEntitiesEnum, FilterEnum } from 'Common/FieldEnum';
import { resetForm } from 'State/forms/actions';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import { DefaultTableState } from 'Common/Constants/table';
import * as FilterSelectors from 'State/filters/selectors';

import {
  ComponentMapping,
  GridNames,
  SortOptions,
  validateStorageLocationForm,
} from '../../../helper/assignEntities';
import {
  clearSubmitError,
  getAllSites,
  getItems,
  getSiteSiteGrpItemByStorageLoc,
  saveAssignEntities,
  clearAssignedStorageLocationData,
} from '../../../state/assignEntities/actions';
import AssignSitesToItemsWithStorageLocation from '../../components/storageLocation/AssignSitesToItemsWithStorageLocation';
import AssignSiteGroupsToItemsWithStorageLocation from '../../components/storageLocation/AssignSiteGroupsToItemsWithStorageLocation';
import * as Selectors from '../../../state/assignEntities/selectors';

class StorageLocation extends Component {
  static propTypes = {
    assignItemsBidGroupData: PropTypes.array.isRequired,
    assignItemsItemGroupData: PropTypes.array.isRequired,
    acctCategoryData: PropTypes.array.isRequired,
    storageLocationData: PropTypes.array.isRequired,
    allSitesData: PropTypes.array.isRequired,
    allItemsData: PropTypes.array.isRequired,
    siteGroupData: PropTypes.array.isRequired,
    allTableStates: PropTypes.object.isRequired,
    initialValues: PropTypes.object.isRequired,
    resetGridPage: PropTypes.object.isRequired,
    getItems: PropTypes.func.isRequired,
    getAllSites: PropTypes.func.isRequired,
    getSiteSiteGrpItemByStorageLoc: PropTypes.func.isRequired,
    clearSubmitError: PropTypes.func.isRequired,
    saveAssignEntities: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    setTableStates: PropTypes.func.isRequired,
    onSubmit: PropTypes.func,
    changeGrid: PropTypes.func,
    setIsReadOnlyState: PropTypes.func,
    onRightGridFilteredChange: PropTypes.func,
    onLeftGridFilteredChange: PropTypes.func,
    onResetPageOnDataChange: PropTypes.func,
    assignedStorageLocationData: PropTypes.object,
    rightSideGridReactTableRef: PropTypes.object,
    leftSideGridReactTableRef: PropTypes.object,
    sortOptionsValue: PropTypes.string.isRequired,
    storageLocationValue: PropTypes.number.isRequired,
    SiteToItemsComponentsWithStorageLocation: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    isRightGridFiltered: PropTypes.bool,
    isLeftGridFiltered: PropTypes.bool,
    prePareInHouse: PropTypes.bool,
  };

  static defaultProps = {
    SiteToItemsComponentsWithStorageLocation: false,
    isReadOnly: true,
    isRightGridFiltered: false,
    isLeftGridFiltered: false,
    rightSideGridReactTableRef: null,
    leftSideGridReactTableRef: null,
    setIsReadOnlyState: () => {},
    onRightGridFilteredChange: () => {},
    onLeftGridFilteredChange: () => {},
    onResetPageOnDataChange: () => {},
    onSubmit: () => {},
    changeGrid: () => {},
    prePareInHouse: false,
    assignedStorageLocationData: null,
  };

  state = {
    filterValues: {
      [FilterEnum.GroupId_Bid]: GenericEnum.InitialFilterValue,
      [FilterEnum.GroupId_Cat]: GenericEnum.InitialFilterValue,
      [FilterEnum.GroupId_Item]: GenericEnum.InitialFilterValue,
    },
    activeIndexes: [0, 1],
  };
  siteGridInstance = null;
  itemGridInstance = null;

  getRenderComponent = () => {
    const { SiteToItemsComponentsWithStorageLocation } = this.props;
    const {
      sortOptionsValue,
      allSitesData,
      allItemsData,
      siteGroupData,
      setIsReadOnlyState,
      isReadOnly,
      prePareInHouse,
      isRightGridFiltered,
      onRightGridFilteredChange,
      rightSideGridReactTableRef,
      isLeftGridFiltered,
      leftSideGridReactTableRef,
      onLeftGridFilteredChange,
      resetGridPage,
      onResetPageOnDataChange,
    } = this.props;
    const commonProps = {
      sortOptionsValue,
      setIsReadOnlyState,
      isReadOnly,
      setSiteGridInstance: this.setSiteGridInstance,
      setItemGridInstance: this.setItemGridInstance,
      isRightGridFiltered,
      onRightGridFilteredChange,
      rightSideGridReactTableRef,
      isLeftGridFiltered,
      leftSideGridReactTableRef,
      onLeftGridFilteredChange,
      resetGridPage,
      onResetPageOnDataChange,
    };
    const filterValues = {};
    _.map(this.state.filterValues, (value, key, items) => {
      if (+items[key]) {
        filterValues[key] = items[key];
      }
    });
    if (prePareInHouse) {
      filterValues[FilterEnum.PrepareInHouse] = prePareInHouse;
    }
    const newData = Object.keys(filterValues).length
      ? _.filter(allItemsData, filterValues)
      : allItemsData;
    if (SiteToItemsComponentsWithStorageLocation) {
      return (
        <AssignSitesToItemsWithStorageLocation
          {...commonProps}
          allSitesData={allSitesData}
          allItemsData={newData}
        />
      );
    } else {
      return (
        <AssignSiteGroupsToItemsWithStorageLocation
          {...commonProps}
          siteGroupData={siteGroupData}
          allItemsData={newData}
        />
      );
    }
  };
  clearFilter = () => {
    const { siteGridInstance, itemGridInstance } = this;
    siteGridInstance && siteGridInstance.clearTableState();
    itemGridInstance && itemGridInstance.clearTableState();
    const { allTableStates, setTableStates } = this.props;
    setTableStates({
      ...allTableStates,
      [TableNamesEnum.ASSIGN_ENTITIES_STORAGE_LOCATION_SITE_GRID_TABLE]: DefaultTableState,
      [TableNamesEnum.ASSIGN_ENTITIES_STORAGE_LOCATION_ITEM_GRID_TABLE]: DefaultTableState,
    });
    const { change } = this.props;
    this.setState({
      filterValues: {
        [FilterEnum.GroupId_Bid]: GenericEnum.InitialFilterValue,
        [FilterEnum.GroupId_Cat]: GenericEnum.InitialFilterValue,
        [FilterEnum.GroupId_Item]: GenericEnum.InitialFilterValue,
      },
    });
    change(FilterEnum.GroupId_Bid, GenericEnum.InitialFilterValue);
    change(FilterEnum.GroupId_Cat, GenericEnum.InitialFilterValue);
    change(FilterEnum.GroupId_Item, GenericEnum.InitialFilterValue);
    change(FilterEnum.PrepareInHouse, false);
    this.props.onResetPageOnDataChange({
      [GridNames.Site]: false,
      [GridNames.Item]: true,
    });
  };

  handleStorageLocationChange = (e, storageLocationId, prevValue) => {
    if (storageLocationId === prevValue) {
      return;
    }
    this.resetPage();
    if (storageLocationId === GenericEnum.ZeroString) {
      return;
    }
    this.props.getSiteSiteGrpItemByStorageLoc(storageLocationId);
    this.props.onResetPageOnDataChange({
      [GridNames.Site]: true,
      [GridNames.Item]: true,
    });
    this.props.clearAssignedStorageLocationData();
  };
  handleDropDownChange = (e, values) => {
    this.setState({
      filterValues: values,
    });
    this.props.onResetPageOnDataChange({
      [GridNames.Item]: true,
      [GridNames.Site]: false,
    });
  };
  handleChangeKitchenItem = () => {
    this.props.onResetPageOnDataChange({
      [GridNames.Item]: true,
      [GridNames.Site]: false,
    });
  };
  resetPage = () => {
    this.props.change(AssignEntitiesEnum.ItemGridInfo, []);
    this.props.change(AssignEntitiesEnum.SiteGridInfo, []);
    this.props.change(AssignEntitiesEnum.SiteGroupGridInfo, []);
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexes } = this.state;
    const activeIndexesClone = [...this.state.activeIndexes];
    activeIndexes.indexOf(index) !== -1
      ? activeIndexesClone.splice(activeIndexes.indexOf(index), 1)
      : activeIndexesClone.push(index);
    this.setState({ activeIndexes: activeIndexesClone });
  };
  setSiteGridInstance = ref => {
    this.siteGridInstance = ref;
  };
  setItemGridInstance = ref => {
    this.itemGridInstance = ref;
  };

  render() {
    const {
      sortOptionsValue,
      handleSubmit,
      assignItemsBidGroupData,
      assignItemsItemGroupData,
      acctCategoryData,
      storageLocationValue,
      storageLocationData,
      changeGrid,
    } = this.props;
    const { activeIndexes } = this.state;

    const fields = [
      {
        name: FilterEnum.GroupId_Bid,
        component: SelectField,
        type: 'text',
        options: assignItemsBidGroupData,
        label: 'BID GROUP',
      },
      {
        name: FilterEnum.GroupId_Item,
        component: SelectField,
        type: 'text',
        options: assignItemsItemGroupData,
        label: 'ITEM GROUP',
      },
      {
        name: FilterEnum.GroupId_Cat,
        component: SelectField,
        type: 'text',
        options: acctCategoryData,
        label: 'ACCT. CATEGORY',
      },
    ];
    return (
      <Form
        onSubmit={handleSubmit}
        style={{
          marginTop: -34,
        }}
      >
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column width={4} textAlign={'left'}>
              <Field
                name={FilterEnum.GroupId_Location}
                component={SelectField}
                options={storageLocationData}
                value={storageLocationValue}
                type="text"
                label={'Set Storage Location:'}
                onChange={this.handleStorageLocationChange}
              />
            </Grid.Column>
            <Grid.Column width={12} />
          </Grid.Row>
        </Grid>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column width={6}>
              <Accordion fluid styled>
                <Accordion.Title
                  active={activeIndexes.indexOf(0) !== -1}
                  index={0}
                  onClick={this.handleClick}
                >
                  <Icon name="dropdown" />
                  <span className="text-orange">List By</span>
                </Accordion.Title>
                <Accordion.Content active={activeIndexes.indexOf(0) !== -1}>
                  <ReduxFormButtonGroup
                    className={'storage-location-list-by-buttons'}
                    options={SortOptions}
                    value={sortOptionsValue}
                    formName={ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME}
                    fieldName={AssignEntitiesEnum.SortOptions}
                    type={'button'}
                    onChange={value => {
                      if (value === sortOptionsValue) {
                        return;
                      }
                      let name =
                        ComponentMapping.SiteToItemsComponentsWithStorageLocation;
                      if (AssignEntitiesEnum.SiteGroup === value) {
                        name =
                          ComponentMapping.SiteGroupToItemsComponentsWithStorageLocation;
                      }
                      this.clearFilter();
                      this.resetPage();
                      this.props.change(
                        [FilterEnum.GroupId_Location],
                        GenericEnum.InitialFilterValue
                      );
                      changeGrid(name);
                    }}
                  />
                </Accordion.Content>
              </Accordion>
            </Grid.Column>

            <Grid.Column width={10}>
              <Accordion fluid styled>
                <Accordion.Title
                  active={activeIndexes.indexOf(1) !== -1}
                  index={1}
                  onClick={this.handleClick}
                >
                  <Icon name="dropdown" />
                  <span className="text-orange">Filter By</span>
                </Accordion.Title>
                <Accordion.Content active={activeIndexes.indexOf(1) !== -1}>
                  <Grid className={'remove-spacing'}>
                    <GenericFiltersContainer
                      fields={fields}
                      onChange={this.handleDropDownChange}
                      filterValues={this.state.filterValues}
                    />
                    <Grid.Column width={6}>
                      <Field
                        component={CheckboxField}
                        name={FilterEnum.PrepareInHouse}
                        label={'KITCHEN ITEM'}
                        className={'kitchen-item-label'}
                        toggle={true}
                        onChange={this.handleChangeKitchenItem}
                      />
                    </Grid.Column>
                    <Grid.Column
                      floated={'right'}
                      width={6}
                      textAlign={'right'}
                    >
                      <Button
                        content="Clear Filters"
                        type={'button'}
                        onClick={this.clearFilter}
                      />
                    </Grid.Column>
                  </Grid>
                </Accordion.Content>
              </Accordion>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column width={6}>
              <span className={'grid-title'}>Ordering Site</span>
            </Grid.Column>
            <Grid.Column width={10}>
              <span className={'grid-title'}>Inventory Items</span>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {this.getRenderComponent()}
      </Form>
    );
  }
}

const selector = formValueSelector(ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME);
const mapStateToProps = state => {
  return {
    sortOptionsValue: selector(state, AssignEntitiesEnum.SortOptions),
    storageLocationValue: selector(state, FilterEnum.GroupId_Location),
    prePareInHouse: selector(state, FilterEnum.PrepareInHouse),
    allTableStates: getTableStates(state),

    assignItemsBidGroupData: FilterSelectors.selectBidGroupData(state),
    assignItemsItemGroupData: FilterSelectors.selectItemGroupData(state),
    acctCategoryData: FilterSelectors.selectAcctCategoryData(state),
    storageLocationData: FilterSelectors.selectStorageLocationDataRemoveEmpty(
      state
    ),

    allSitesData: Selectors.getAllSitesData(state),
    allItemsData: Selectors.getAllItemsData(state),
    siteGroupData: Selectors.getSiteGroupData(state),
    assignedStorageLocationData: Selectors.getAssignedStorageLocationData(
      state
    ),
  };
};
const mapDispatchToProps = {
  getItems,
  getAllSites,
  getSiteSiteGrpItemByStorageLoc,
  clearSubmitError,
  saveAssignEntities,
  resetForm,
  setTableStates,
  clearAssignedStorageLocationData,
};
StorageLocation = connect(
  mapStateToProps,
  mapDispatchToProps
)(StorageLocation);

export const StorageLocationForm = reduxForm({
  form: ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateStorageLocationForm,
})(StorageLocation);



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/containers/storageLocation/StorageLocationForm.js